var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"search-body",attrs:{"fluid":""}},[_c('results',{attrs:{"searchResults":_vm.results}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }